import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import plugins from './plugins';
import globalMix from './mixins/global';
import ElementUI from 'element-ui';
import moment from 'moment';

import './assets/css/app.scss';
import './assets/css/reset.css';
import 'element-ui/lib/theme-chalk/index.css';

Vue.prototype.$moment = moment;

Vue.config.productionTip = false;

Vue.use(plugins);
Vue.use(ElementUI);

Vue.mixin(globalMix);

Vue.routerGo = function (option, isReplace) {
  const routerFn = isReplace ? router.replace : router.push;
  const routerGo = () => {
    routerFn.call(router, option);
  };
  routerGo();
};

export default new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app');
